// extracted by mini-css-extract-plugin
module.exports = {"serviceList":"ServiceList_serviceList__ZGHTt"};